import styled from 'styled-components';
import ds, { media } from 'designsystem';
import { Row } from 'hedron';
import Container from 'blocks/Container/Container';
import CALCULATOR from 'common/consts/calculator';
import Arrow from 'blocks/Arrow/Arrow';

export const Heading = styled.h2`
  font-size: ${ds.fs('l')};
  font-family: ${ds.get('type.fontFamily.text')};
  padding-top: ${ds.get('metrics.s')};
  padding-bottom: ${ds.get('metrics.s')};
`;

export const ParagraphWhite = styled.p`
  color: ${ds.brand('white')};
  font-family: ${ds.get('type.fontFamily.text')};
  line-height: ${ds.get('type.lineHeight.base')};
  font-size: ${ds.fs('base')};
  font-weight: ${ds.get('type.fontWeight.light')};
  margin: ${ds.get('metrics.s')} 0;

  ${media.desktop`
    margin: 0;
    line-height: ${ds.get('type.lineHeight.base')};
  `}
`;

export const ButtonTextWhite = styled.button`
  position: relative;
  color: ${ds.brand('white')};
  font-family: ${ds.get('type.fontFamily.text')};
  font-size: ${({ big }) => (big ? ds.fs('l') : ds.fs('m'))};
  font-weight: ${ds.get('type.fontWeight.light')};
  cursor: pointer;
  z-index: 2;
  background: none;
  padding: 0;
  border: none;
  outline: none;
  transition-duration: 0.2s;
  white-space: nowrap;

  &:hover {
    opacity: 0.7;
  }

  ${({ mobileToRight }) => (mobileToRight ? `
    text-align: end;
  ` : '')}
  
  ${media.desktop`
    text-align: start;
  `}
`;

export const CalculatorContainer = styled(Container)`
  position: relative;

  ${media.desktop`
      height: ${CALCULATOR.desktopHeight}px;
  `}
`;

export const ParagraphWhiteBig = styled.p`
  color: ${ds.brand('white')};
  font-size: ${ds.fs('l')};
  line-height: ${ds.get('type.lineHeight.l')};
  font-family: ${ds.get('type.fontFamily.text')};
  font-weight: ${ds.get('type.fontWeight.light')};
  margin-top: ${({ marginTop }) => (marginTop ? `${marginTop}px` : 0)};
  margin-bottom: 0;

  ${media.desktop`
      margin-bottom: ${ds.get('metrics.s')};
  `}
`;

export const WhiteHeadline = styled.p`
  font-family: ${ds.get('type.fontFamily.headline')};
  font-weight: ${ds.get('type.fontWeight.regular')};
  color: ${ds.brand('white')};
  margin-top: ${ds.get('metrics.xs')};
  margin-bottom: ${ds.get('metrics.xs')};
  font-size: ${ds.fs('xl')};
  line-height: ${ds.get('type.lineHeight.l')};

  ${media.tablet`
    font-size: ${ds.fs('xxl')};
    line-height: ${ds.get('type.lineHeight.xl')};
  `}
`;

export const WhiteArrow = styled(Arrow)`
  position: relative;
  display: inline-block;
  margin-left: ${ds.get('metrics.xs')};
  border-color: ${ds.brand('white')};
  width: 10px;
  height: 10px;
  top: -2px;
`;

export const Price = styled.span`
  font-weight: ${ds.get('type.fontWeight.bold')};
  white-space: nowrap;
`;

export const Currency = styled.span`
  font-size: ${ds.fs('base')};
  font-weight: ${ds.get('type.fontWeight.bold')};
`;

export const PaddedTopRow = styled(Row)`
  ${media.tablet`
    padding-top: ${ds.get('metrics.s')};
  `}
`;

export const PaddedBottomRow = styled(Row)`
  padding-bottom: ${ds.get('metrics.s')};
`;

export const WhiteHorizontalLine = styled.hr`
  border: none;
  border-top: 1px solid ${ds.brand('white')};
  width: 100%;
  height: 0;
  opacity: 0.1;
  margin: ${ds.get('metrics.s')} 0;
  
  ${({ noMarginBottom }) => (noMarginBottom ? 'margin-bottom: 0;' : '')}
`;



// WEBPACK FOOTER //
// ./src/kentico-blocks/Calculator/styled.jsx